import { UNISWAP_V3_POOL_FACTORY_CONTRACT_MAINNET, UNISWAP_V3_QUOTER_ABI, UNISWAP_V3_QUOTER_CONTRACT_MAINNET, viemClientByChainId, } from '@shapeshiftoss/contracts';
import { Err, Ok } from '@sniptt/monads';
import assert from 'assert';
import { getContract } from 'viem';
import { TradeQuoteError } from '../../../types';
import { makeSwapErrorRight } from '../../../utils';
import { feeAmountToContractMap, generateV3PoolAddressesAcrossFeeRange, getContractDataByPool, getQuotedAmountOutByPool, selectBestRate, } from './longTailHelpers';
export const getBestAggregator = async (buyAsset, sellToken, buyToken, sellAmountIncludingProtocolFeesCryptoBaseUnit) => {
    const publicClient = viemClientByChainId[buyAsset.chainId];
    assert(publicClient !== undefined, `no public client found for chainId '${buyAsset.chainId}'`);
    const poolAddresses = generateV3PoolAddressesAcrossFeeRange(UNISWAP_V3_POOL_FACTORY_CONTRACT_MAINNET, sellToken, buyToken);
    const poolContractData = getContractDataByPool(poolAddresses, publicClient, sellToken.address, buyToken.address);
    const quoterContract = getContract({
        abi: UNISWAP_V3_QUOTER_ABI,
        address: UNISWAP_V3_QUOTER_CONTRACT_MAINNET,
        client: publicClient,
    });
    const quotedAmountOutByPool = await getQuotedAmountOutByPool(poolContractData, BigInt(sellAmountIncludingProtocolFeesCryptoBaseUnit), quoterContract);
    const [bestPool, quotedAmountOut] = selectBestRate(quotedAmountOutByPool);
    const bestContractData = bestPool ? poolContractData.get(bestPool) : undefined;
    const bestAggregator = bestContractData ? feeAmountToContractMap[bestContractData.fee] : undefined;
    if (!bestAggregator || !quotedAmountOut) {
        return Err(makeSwapErrorRight({
            message: `[getThorTradeQuote] - No best aggregator contract found.`,
            code: TradeQuoteError.UnsupportedTradePair,
        }));
    }
    return Ok({ bestAggregator, quotedAmountOut });
};
